import { privacyPolicyLink, learnMorePwdLessLink, learnMoreIdpLink, surveyLink } from "../common/constants";

const FooterLinks = (props)=> {
    const { user } = props;
return (
     <div className="link-container">
              {/* Links */}
              {!user.enforcedEnrollment && (
                <a
                  href={learnMorePwdLessLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="learn-more-pwd-less"
                >
                  Learn More About Passwordless
                </a>
              )}
              <a
                href={learnMoreIdpLink}
                target="_blank"
                rel="noopener noreferrer"
                className="learn-more-pwd-less"
              >
                Learn More About Identity Verification
              </a>

              <a
                href={privacyPolicyLink}
                target="_blank"
                rel="noopener noreferrer"
                className="learn-more-pwd-less"
              >
                Privacy Policy
              </a>
              {!user.enforcedEnrollment && (
                <a
                  href={surveyLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="survey"
                >
                  Identity Verification Enrollment Survey
                </a>
              )}
            </div>
)
};

export default FooterLinks;